<template>
    <div class="result_item">
        <div class="sticker__blck"  v-if="itemData.label">
            <img src="/img/icon/stiker.svg" alt="">
        </div>
        <div class="row">
            <div class="col-lg-3 col-md-6 d-flex align-items-stretch">
                <div class="result_logo">
                    <div class="logo">
                        <img :src="itemData.image" alt="">
                        <router-link
                                :to="{name: 'companyPage', params: { id: 3 }}"
                                :class="'p-light-green min'"
                        >E.ON Energilosningar Aktiebolag abracadabra</router-link>
                    </div>
                    <div class="right__info" v-if="isMobile">
                        <div class="mini-popup" v-if="active2"  :class="{'active': active2}"  @click="active2 = !active2">
                            <div class="m_popup__blck">
                                <div class="row">
                                    <div class="col-9">
                                        <div class="title">
                                            <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                            <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                        </div>
                                    </div>
                                    <div class="col-3 d-flex align-items-center justify-content-end">
                                        <div class="cost">
                                            <p class="p-dgrey med-max">45.90</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-9">
                                        <div class="title">
                                            <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                            <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                        </div>
                                    </div>
                                    <div class="col-3 d-flex align-items-center justify-content-end">
                                        <div class="cost">
                                            <p class="p-dgrey med-max">45.90</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-9">
                                        <div class="title">
                                            <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                            <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                        </div>
                                    </div>
                                    <div class="col-3 d-flex align-items-center justify-content-end">
                                        <div class="cost">
                                            <p class="p-dgrey med-max">45.90</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-9">
                                        <div class="title">
                                            <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                            <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                        </div>
                                    </div>
                                    <div class="col-3 d-flex align-items-center justify-content-end">
                                        <div class="cost">
                                            <p class="p-dgrey med-max">45.90</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-7">
                                        <div class="total">
                                            <p class="p-blue">Total:</p>
                                        </div>
                                    </div>
                                    <div class="col-5">
                                        <div class="total-cost">
                                            <p class="p-yellow">45.90</p>
                                            <p class="min">öre / kWh incl</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="cost">
                            <p class="p-yellow cost-text">78.01</p>
                            <p class="min">öre / kWh incl
                                <span class="quest__in_icon"
                                      :class="{'active': active2}"
                                      @click="active2 = !active2"
                                ></span>
                            </p>
                        </div>

                    </div>


                </div>
            </div>
            <div class="col-lg-7 col-md-4">
                <div class="result_info">

                    <div class="row">
                        <div class="col-lg-5  d-flex align-items-stretch">

                            <div class="left__info">
                                <div class="contract__name">
                                    <p class="min relawaySM">Fastpris 6 manader</p>
                                </div>
                                <div class="main_quest__info">


                                    <div class="quest__info">
                                        <p class="p-light-green med">Fast  price
                                            <span class="quest__in_icon" :class="{'active': active1}" @click="active1 = !active1">
                                            </span>
                                        </p>
                                        <div class="mini-popup" v-if="active1"  :class="{'active': active1}"  @click="active1 = !active1">
                                            <div class="m_popup__blck">
                                                <div class="title">
                                                    <p class="Raleway min p-dgrey"><b>Variable price</b></p>
                                                </div>
                                                <div class="content">
                                                    <p class="min-min p-dgrey">A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p class="min notice">Uppsainingstid: <br /> <b>1 month</b></p>
                                <p class="annual p-light-green med"><b>Annual cost: <span class="p-dgrey min">5461 kr</span></b></p>
                                <div class="icon_list"  v-if="isMobile && itemData.typeenergy">
                                    <div class="icon_list">
                                        <div class="icon" :class="{'active': active3}">
                                            <img src="/img/icon/weather/wind.svg" alt=""   @click="active3 = !active3">
                                            <div class="mini-popup" v-if="active3"  :class="{'active': active3}">
                                                <div class="m_popup__blck">
                                                    <div class="title">
                                                        <p class="Raleway min p-dgrey"><b>Variable price</b></p>
                                                    </div>
                                                    <div class="content">
                                                        <p class="min-min p-dgrey">A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="icon" :class="{'active': active4}">
                                            <img src="/img/icon/weather/sun.svg" alt=""   @click="active4 = !active4">
                                            <div class="mini-popup" v-if="active4"  :class="{'active': active4}">
                                                <div class="m_popup__blck">
                                                    <div class="title">
                                                        <p class="Raleway min p-dgrey"><b>Variable price</b></p>
                                                    </div>
                                                    <div class="content">
                                                        <p class="min-min p-dgrey">A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="icon_list"  v-if="isMobile && !itemData.typeenergy" >
                                    <p class="no_energy"
                                       @click="active4 = !active4"
                                       :class="{'active': active4}"
                                    ><b>no energy at all</b></p>
                                    <div class="mini-popup" v-if="active4"  :class="{'active': active4}">
                                        <div class="m_popup__blck">
                                            <div class="title">
                                                <p class="Raleway min p-dgrey"><b>Variable price</b></p>
                                            </div>
                                            <div class="content">
                                                <p class="min-min p-dgrey">A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1 d-none d-md-block"></div>
                        <div class="col-lg-6">
                            <div class="right__info" v-if="!isMobile">
                                <div class="mini-popup" v-if="active2"  :class="{'active': active2}"  @click="active2 = !active2">
                                    <div class="m_popup__blck">
                                        <div class="row">
                                            <div class="col-9">
                                                <div class="title">
                                                    <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                    <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                                </div>
                                            </div>
                                            <div class="col-3 d-flex align-items-center justify-content-end">
                                                <div class="cost">
                                                    <p class="p-dgrey med-max">45.90</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-9">
                                                <div class="title">
                                                    <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                    <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                                </div>
                                            </div>
                                            <div class="col-3 d-flex align-items-center justify-content-end">
                                                <div class="cost">
                                                    <p class="p-dgrey med-max">45.90</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-9">
                                                <div class="title">
                                                    <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                    <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                                </div>
                                            </div>
                                            <div class="col-3 d-flex align-items-center justify-content-end">
                                                <div class="cost">
                                                    <p class="p-dgrey med-max">45.90</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-9">
                                                <div class="title">
                                                    <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                    <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                                </div>
                                            </div>
                                            <div class="col-3 d-flex align-items-center justify-content-end">
                                                <div class="cost">
                                                    <p class="p-dgrey med-max">45.90</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-9">
                                                <div class="title">
                                                    <p class="Raleway min p-dgrey"><b>Electricity price</b></p>
                                                    <p class="p-gray2 minimum">(incl. electricity certificate, excl. VAT)</p>
                                                </div>
                                            </div>
                                            <div class="col-3 d-flex align-items-center justify-content-end">
                                                <div class="cost">
                                                    <p class="p-dgrey med-max">45.90</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-7">
                                                <div class="total">
                                                    <p class="p-blue">Total:</p>
                                                </div>
                                            </div>
                                            <div class="col-5">
                                                <div class="total-cost">
                                                    <p class="p-yellow">45.90</p>
                                                    <p class="min">öre / kWh incl</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="cost">
                                    <p class="p-yellow cost-text">78.01</p>
                                    <p class="min">öre / kWh incl
                                        <span class="quest__in_icon"
                                              :class="{'active': active2}"
                                              @click="active2 = !active2"
                                        ></span>
                                    </p>
                                </div>
                                <div class="icon_list" v-if="itemData.typeenergy">
                                    <div class="icon" :class="{'active': active3}">
                                        <img src="/img/icon/wind.svg" alt=""   @click="active3 = !active3">
                                        <div class="mini-popup" v-if="active3"  :class="{'active': active3}">
                                            <div class="m_popup__blck">
                                                <div class="title">
                                                    <p class="Raleway min p-dgrey"><b>Fast price</b></p>
                                                </div>
                                                <div class="content">
                                                    <p class="min-min p-dgrey">A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="icon" :class="{'active': active4}">
                                        <img src="/img/icon/sun.svg" alt=""   @click="active4 = !active4">
                                        <div class="mini-popup" v-if="active4"  :class="{'active': active4}">
                                            <div class="m_popup__blck">
                                                <div class="title">
                                                    <p class="Raleway min p-dgrey"><b>Variable price</b></p>
                                                </div>
                                                <div class="content">
                                                    <p class="min-min p-dgrey">A variable price follows developments on the Nordic electricity exchange (Nord Pool) and can vary considerably from month to month. The price to the left is based on the average value of the previous month's spot price on the Nord Pool electricity exchange. In addition, the company's possible administrative mark-up, electricity certificate fee and any profile mark-up have been added.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                                <div class="icon_list"  v-if="!itemData.typeenergy" >
                                    <p class="">no energy at all</p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-lg-2 col-md-2 d-flex align-items-stretch">
                <div class="result_btn">
                    <button class="btn btn-green btn-full" @click="$emit('modalActive')">Further</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "OfferResult",
        props: {
            itemData: Object
            },
        data: function(){
            return {
                item: this.itemData,
                active1: false,
                active2: false,
                windowWidth: 0,
                active3: false,
                active4: false,

            }
        },
        methods: {
            handleResize() {
                this.windowWidth = window.innerWidth;
            },


        },
        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },
        destroyed() {
            window.removeEventListener('resize', this.handleResize)
        },
        computed: {
            isMobile: function () {
                if(this.windowWidth > 991){
                    return false;
                } else {
                    return true;
                }

            }
        }


    }
</script>
